// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"styles_errorContainer__2S6Sn","webcam":"styles_webcam__1v3w4"};